import {SlimDocumentDto} from '../services/generated';
import {DocumentVersion} from './DocumentVersion';

export class DocumentSlim extends DocumentVersion implements SlimDocumentDto {}
